'use client'

import React, { useCallback, useEffect } from 'react'
import { useQueryState } from 'nuqs'

import FindPolicy from '@/find-policy/FindPolicy'

import { useStepsStore } from '@/lib/stores/useStepsStore'
import { errorCodeToErrorKey } from '@/lib/utils/helpers'
import LoginLink from '@/login-link/LoginLink'
import { useQueryClient } from '@tanstack/react-query'

export default function Intro() {
    const [step, setStep] = useQueryState('step', { history: 'push', scroll: true })
    const [errorCode, setError] = useQueryState('errorCode', { history: 'push' })
    const queryClient = useQueryClient()

    const resetSteps = useStepsStore((state) => state.resetSteps)

    const errorKey = errorCode
        ? errorCodeToErrorKey?.[errorCode as unknown as keyof typeof errorCodeToErrorKey]
        : undefined

    useEffect(() => {
        // Reset steps when navigating back to intro page.
        resetSteps()
        queryClient.clear()
    }, [queryClient, resetSteps])

    return (
        <>
            {step === 'find-policy' ? (
                <FindPolicy validationErrors={errorCode && errorKey ? { [errorKey]: [''] } : null} />
            ) : (
                <LoginLink validationErrors={errorCode && errorKey ? { [errorKey]: [''] } : null} />
            )}
        </>
    )
}
